import React, { ReactElement } from 'react';
import { Event } from 'services/api';
import { EventStatus } from './EventStatus';

export interface EventHostStatusProps {
  status: Event['status'];
}

const labels: Record<EventHostStatusProps['status'], string> = {
  PENDING_APPROVAL: 'Pending Student Life Approval',
  REJECTED: 'Event Rejected by Student Life',
  PUBLISHED: 'Published',
  FINISHED: 'Event Ended',
  UPDATED: 'Event Details Updated',
  RESCHEDULED: 'Event Rescheduled',
  CANCELLED: 'Event Cancelled',
  EXPIRED: 'Event Expired',
  DRAFT: 'Draft',
};

export const EventHostStatus = ({
  status,
}: EventHostStatusProps): ReactElement => {
  return <EventStatus status={status}>{labels[status]}</EventStatus>;
};
